// extracted by mini-css-extract-plugin
module.exports = {"masterContainer":"g-COo-qSHLTqJsjv6DDjS","nodeLabel":"yVEbGMe6pk-D1hqQZORFw"};